const BRAND_ENUM = {
  VISA: 'Visa',
  MASTERCARD: 'Mastercard',
  HIPERCARD: 'Hipercard',
  DISCOVER: 'Discover',
  DINERS: 'Diners',
  AMEX: 'Amex',
  ELO: 'Elo',
  JCB: 'JCB',
  CREDZ: 'Credz',
  SENFF: 'Senff',
  CABAL: 'Cabal',
  SOROCRED: 'Sorocred',
  BANESCARD: 'Banescard',
  CASSOL: 'Cassol'
}
export { BRAND_ENUM }
